/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-layer-popover-arrow-padding: 0px;
  --nve-sys-layer-popover-arrow-offset: 0px;
  --nve-sys-layer-popover-offset: var(--nve-ref-space-md);
  --nve-sys-interaction-color: var(--color);
  --padding: var(--nve-ref-size-200) var(--nve-ref-size-400);
  --justify-content: initial;
  --background: var(--nve-sys-layer-popover-background);
  --border-radius: var(--nve-ref-border-radius-md);
  --border: none;
  --color: var(--nve-sys-layer-popover-color);
  --font-size: var(--nve-ref-font-size-200);
  --font-weight: var(--nve-ref-font-weight-medium);
  --box-shadow: var(--nve-ref-shadow-100);
  --gap: var(--nve-ref-space-xs);
  --_gap: var(--gap);
  height: fit-content;
}

[internal-host] {
  background: var(--background);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  gap: var(--gap);
  color: var(--color);
  padding: var(--padding);
  border-radius: var(--border-radius);
  border: var(--border);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: var(--justify-content);
}

[internal-host]:has(nve-icon-button) {
  padding-inline-end: var(--nve-ref-size-800);
}

:host([status='accent']) {
  --background: var(--nve-sys-support-accent-color);
}

:host([status='success']) {
  --background: var(--nve-sys-support-success-color);
  --color: var(--nve-sys-text-white-color);
}

:host([status='warning']) {
  --background: var(--nve-sys-support-warning-color);
  --color: var(--nve-sys-text-black-color);
}

:host([status='danger']) {
  --background: var(--nve-sys-support-danger-color);
  --color: var(--nve-sys-text-white-color);
}

:host([prominence='muted']:not([status])) {
  --background: var(--nve-sys-support-muted-color);
  --color: var(--nve-sys-layer-popover-background);
}

nve-icon {
  --color: inherit;
}

nve-icon-button {
  --color: inherit;
  position: absolute;
  inset-block-start: var(--nve-ref-size-50);
  inset-inline-end: var(--nve-ref-size-50);
}

::slotted(nve-button[container='flat']),
::slotted(nve-button[container='inline']) {
  --color: inherit;
  margin-inline: calc(var(--_gap) * 2) calc(var(--_gap) / -2);
}

::slotted([nve-text]) {
  color: inherit !important;
}
